import { Box, Tooltip } from '@mui/material';
import React from 'react';

interface TextOverlappingProps {
    value: string;
    maxLength?: number;
    maxWidth?: number;
}

export const TextOverlapping = ({
    value,
    maxLength,
    maxWidth = 150,
}: TextOverlappingProps) => {
    if (maxLength && value?.length > maxLength) {
        return (
            <Tooltip title={value}>
                <Box
                    sx={{
                        display: 'block',
                        whiteSpace: 'nowrap',
                        wordWrap: 'break-word',
                        lineHeight: 'body2.lineHeight',
                        maxWidth,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {value}
                </Box>
            </Tooltip>
        );
    }

    return <>{value}</>;
};
